import { Season } from 'app/frontend/types/custom'
import seasonData from '../../../../config/static_data/seasons.json'
import { uniqBy } from 'lodash'

export function getDungeons(): Season['keystone_dungeons'] {
  return uniqBy(
    seasonData
      .filter((season) => !!season.metadata)
      .flatMap(
        (season) => season.metadata.keystone_dungeons,
      ) as Season['keystone_dungeons'],
    'id',
  )
}
